import React, { useEffect, useRef, useState } from 'react';
import 'ol/ol.css';

import Map from "ol/Map";
import View, { FitOptions } from "ol/View";
import Projection from "ol/proj/Projection";
import { getCenter, Extent } from 'ol/extent';
import ImageLayer from 'ol/layer/Image';
import Static from 'ol/source/ImageStatic';
import { ImageMap } from '../types';
import { isSafeImageUrl } from "../../../../helpers";
import { DEFAULT_FIELD } from 'config/constants/commons';

/* eslint-disable */

const zoom = 1;
const maxZoom = 8;

const getMapView = (projection: Projection, extent: Extent) => {
  return new View({
    zoom,
    maxZoom,
    projection,
    center: getCenter(extent),
  });
};

const getMapProjection = (extent: Extent) => {
  return new Projection({
    extent,
    units: 'pixels',
    code: 'xkcd-image'
  });
};

const getMapImageLayer = (
  projection: Projection,
  imageURL: string,
  imageExtent: Extent
) => {
  const [, , width, height] = imageExtent;

  return new Static({
    projection,
    imageExtent,
    imageSize: [width, height],
    url: '',
    imageLoadFunction: (image: any) => {
      const img = image.getImage();

      let safeSrc: string;
      if (isSafeImageUrl(imageURL)) {
        safeSrc = imageURL;
      } else if (isSafeImageUrl(DEFAULT_FIELD.image)) {
        safeSrc = DEFAULT_FIELD.image;
      } else {
        safeSrc = "";
      }
      img.src = safeSrc;
    }
  });
};

export default ({ field, setField, mapImage, dimensions, practiceMap, setPracticeMap } : ImageMap) => {
  const mapContainer: React.Ref<HTMLDivElement>= useRef(null);
  const [imageFlag, setImageFlag] = useState('');

  useEffect(() => {
    if (dimensions && dimensions.length && field._id !== imageFlag) {
      const [width, height] = dimensions;
      const extent: Extent = [0, 0, width, height];
      const projection = getMapProjection(extent);
      const view = getMapView(projection, extent);

      if (!practiceMap) {
        const imageLayer = new ImageLayer({
          source: getMapImageLayer(projection, mapImage, extent)
        });
        initOpenLayersMap(imageLayer, view);
      } else {
        const imageLayer = practiceMap.getLayers().getArray()[0] as ImageLayer<any>;
        imageLayer.setSource(getMapImageLayer(projection, mapImage, extent));
        practiceMap.setView(view);
        practiceMap.getView().fit(extent, practiceMap.getSize() as FitOptions);
        practiceMap.getView().setZoom(practiceMap.getView().getZoom()! - 0.1);
      }

      setImageFlag(field._id);
      setField({ ...field, isLoading: false });
    }
  }, [dimensions]);

  const initOpenLayersMap = (imageLayer: ImageLayer<any>, view: View) => {
    const map = new Map({
      layers: [imageLayer],
      target: undefined,
      controls: []
    });
    map.setView(view);
    map.setTarget(mapContainer.current as HTMLDivElement);
    setPracticeMap(map);
  };

  return (
    <div ref={mapContainer} className="ol-map" />
  );
}
